// SC-1091 — « Ajouter à Apple Wallet / Google Wallet » (spec §7.4). The hub hands
// out signed URLs that expire in 10 minutes; the page re-reads the card before
// following one that is older than 8.

export type WalletPlatform = 'apple' | 'google';

/** Signed URLs live 10 min server-side; refetch past 8 to keep a safe margin. */
export const WALLET_URL_MAX_AGE_MS = 8 * 60 * 1000;

/**
 * Which button comes first: iOS → Apple, Android → Google, a computer → both,
 * Apple first. iPadOS 13+ reports a Mac user agent — a touch screen tells it apart.
 */
export function walletOrder(userAgent: string, maxTouchPoints = 0): WalletPlatform[] {
  const isIos = /iPhone|iPad|iPod/.test(userAgent) || (/Macintosh/.test(userAgent) && maxTouchPoints > 1);
  if (!isIos && /Android/i.test(userAgent)) return ['google', 'apple'];
  return ['apple', 'google'];
}

/** True when a card read at `fetchedAt` may carry an expired signed URL. */
export function walletUrlIsStale(fetchedAt: number | undefined, now: number = Date.now()): boolean {
  return fetchedAt === undefined || now - fetchedAt > WALLET_URL_MAX_AGE_MS;
}

/**
 * Navigation goes through this object so a test can watch it: jsdom cannot
 * navigate and `window.location` cannot be replaced.
 */
export const walletNav = {
  /** Apple: same tab — Safari opens the « add to Wallet » sheet on the .pkpass. */
  assign(url: string): void {
    window.location.assign(url);
  },
  /** Google: a new tab. The blank tab is opened synchronously (inside the tap) so a
   *  popup blocker lets it through, then pointed at the URL once it is fresh. */
  openBlank(): Window | null {
    const tab = window.open('', '_blank');
    if (tab) tab.opener = null;
    return tab;
  },
  openIn(tab: Window | null, url: string): void {
    if (tab) tab.location.href = url;
    else window.open(url, '_blank', 'noopener,noreferrer');
  },
};
